/**
 * DonorTile — single tile on the donor wall.
 *
 * Shared by OrgShowcasePanel. Null-safe on `designation` and `source`
 * — chip/badge are suppressed when absent.
 */

import { sourceBadgeLabel } from './source-badge.js';

export interface DonorTileOptions {
  readonly donorDisplay: string;
  readonly amountDisplay: string;
  readonly designation?: string | null;
  readonly source?: string | null;
}

export function renderDonorTile(opts: DonorTileOptions): HTMLElement {
  const tile = document.createElement('div');
  tile.className = 'ag-wall__tile';

  const donor = document.createElement('div');
  donor.className = 'ag-wall__donor';
  donor.textContent = opts.donorDisplay;
  tile.appendChild(donor);

  const amount = document.createElement('div');
  amount.className = 'ag-wall__amount';
  amount.textContent = opts.amountDisplay;
  tile.appendChild(amount);

  const designation = (opts.designation ?? '').trim();
  if (designation) {
    const chip = document.createElement('div');
    chip.className = 'ag-designation-chip';
    chip.textContent = `→ ${designation}`;
    tile.appendChild(chip);
  }

  const sourceLabel = sourceBadgeLabel(opts.source ?? null);
  if (sourceLabel) {
    const badge = document.createElement('span');
    badge.className = 'ag-source-badge';
    badge.textContent = sourceLabel;
    tile.appendChild(badge);
  }

  return tile;
}
